module.exports = __webpack_public_path__ + "static/img/connectionFail.8541b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connectionFail.png
// module id = 279
// module chunks = 1